import { BaseModel,  Attachment } from 'src/app/shared/models';

export class PayappItem extends BaseModel {

  // for CASL subject detection on code minification
  static get modelName() { return 'PayappItem'; }

  /* tslint:disable */
  site_name: string;
  report_date: Date|any;
  daily_report_id: string;
  item: string;
  description: string;
  bid_item_quantity: number;
  unit_price: number;
  quantity: number;
  pay_app_quantity?: number;
  reported_quantity?: number;
  paid_quantity?: number;
  bid_item_key?: number;
  contract_remaining?: number;
  deferred_quantity?: number;
  deferral_reason?: string;
  uom: string;
  pay_app_status: string;
  pay_app_comments: string;
  contractor_status: string;
  contractor_comments: string;
  contractor_suggested_quantity: number;
  contractor_pictures: Attachment[];
  report_bid_item_id: string;
  pay_app_id: number;
  site_id: string;
  created_by_id: string;
  created_by: string;

  // NEW fields for G703 display
  original_quantity?: number;
  change_order_quantity?: number;
  adjusted_quantity?: number;
  quantity_previous?: number;
  quantity_to_date?: number;
  percent_complete?: number;
  amount?: number;
  created_by_name?: string;
  moh?: {
    uuid: string;
    opening_balance: number;
    advance_added: number;
    drawdown: number;
    closing_balance: number;
    D: number;
    E: number;
    F: number;
    G: number;
    attachments?: any[];
  };
  /* tslint:enable */

  static toPayload(
    payappItems: PayappItem[], 
    itemMaps: { [key: string]: any }, 
    payappName: string
  ): { name: string, paid: any[], deferred: any[], rejected: any[] } {
      return payappItems.reduce((acc, item) => {
      const status = itemMaps?.status[item.report_bid_item_id] || 'ready';
      const comments = itemMaps?.comments[item.report_bid_item_id] || '';
      const key = status === 'deferred' ? 'deferred' : status === 'rejected' ? 'rejected' : 'paid';
      acc[key].push({
        id: item.report_bid_item_id,
        comments: comments,
        quantity: itemMaps?.quantity?.[item.report_bid_item_id] ?? item.quantity
      });
      return acc;
    }, { name: payappName, paid: [], deferred: [], rejected: [] });
  }
}
